<template>
  <!-- 文章详情 -->
  <div class="article-page">
    <bscroll-view>
      <div class="article_details_wap">
        <div class="article_details">
          <div class="ad_title">{{ articleDetail.Title }}</div>
          <div class="ad_jj">
            <div>{{ articleDetail._from }}</div>
            <div>
              {{ articleDetail.Columns ? `栏目：${articleDetail.Columns}` : "" }}
            </div>
            <div>
              {{ articleDetail.Author ? `作者：${articleDetail.Author}` : "" }}
            </div>
          </div>
          <div class="details_wap">
            <div
                class="conent-bind"
                v-if="articleDetail.Content"
                v-html="articleDetail.Content"
            ></div>
          </div>
        </div>
        <footer-com/>
      </div>
    </bscroll-view>
    <!-- 仅手语阅览室(URL signLang=1)挂载数字人 -->
    <sign-language-digital-human v-if="$route.query.signLang == '1'"/>
  </div>
</template>

<script>
import {getArticleDetail} from "@/api/lyl";
import BscrollView from "@/components/bscrollView";
import FooterCom from "@/components/footerCom/footerCom";
import SignLanguageDigitalHuman from "@/components/signLanguageDigitalHuman";

export default {
  name: "article_details",
  data() {
    return {
      showwxbox: false,
      articleDetail: {},
      cutSumNumber: 500,
    };
  },
  components: {
    FooterCom,
    BscrollView,
    SignLanguageDigitalHuman,
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
  },
  watch: {
    // webInfo(newVal) {
    //   if (newVal.service_code) {
    //     this.getQrcode();
    //   }
    // },
  },
  methods: {
    async getArticleDetail(TitleID) {
      try {
        const params = {
          TitleID,
        };
        const {articleDetail} = await getArticleDetail(params);
        const [baseData] = articleDetail;
        baseData._from = `来源：${baseData.MagazineName} ${baseData.Year}年第${baseData.Issue}期`;
        this.articleDetail = baseData;
      } catch (error) {
        console.log(error);
      }
    },
    // async getQrcode() {
    //   let data2 = {
    //     type: 1,
    //     service_code: this.webInfo.service_code,
    //     user_unique_code: this.user_unique_code,
    //   };
    //   let params = Object.assign(this.params, data2);
    //   try {
    //     const data = await qrCode(params);
    //   } catch (err) {}
    // },
  },
  created() {
  },
  mounted() {
    const {TitleID, dataParams} = this.$route.query;
    // this.params = Object.assign({}, JSON.parse(dataParams));
    this.getArticleDetail(TitleID);
    // this.getQrcode();
  },
};
</script>

<style scoped lang="less">
// 页面根:作为手语数字人悬浮球(position:absolute)的定位参照,且不随内容滚动
.article-page {
  position: relative;
  width: 100%;
  height: 100%;
}
.article_details_wap {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .article_details {
    width: 960px;
    margin: 40px 0;
    border-radius: 6px 6px 0 0;
    background-color: rgb(240, 242, 245);
    padding: 60px 40px;
    box-sizing: border-box;

    .ad_title {
      font-size: 30px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
    }

    .ad_jj {
      font-size: 14px;
      font-weight: 500;
      color: #ababab;
      line-height: 20px;
      margin-top: 20px;
      display: flex;
      // justify-content: space-between;

      div {
        max-width: 500px;
        margin-right: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      div:last-child {
        margin-right: 0;
      }
    }

    .details_wap {
      margin-top: 48px;
      font-size: 18px;
      color: rgba(51, 51, 51, 1);
      line-height: 32px;
      text-indent: 2em;
    }
  }
}
</style>

<style>
.conent-bind img {
  width: 840px;
  margin: 1em auto;
  display: block;
}

/* .conent-bind figure img {
  width: 840px;
  margin-left: 0;
} */
</style>

